class JbcFormatSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.refresh);
    this.addEventListener('click', this.handleTabClick);
    this.addEventListener('keydown', this.handleTabKey);
    this.observer = new MutationObserver(this.refresh);
    this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });
    this.refresh();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.removeEventListener('change', this.refresh);
    this.removeEventListener('click', this.handleTabClick);
    this.removeEventListener('keydown', this.handleTabKey);
  }
  refresh = () => {
    const labels = Array.from(this.querySelectorAll('label[data-format-family]'));
    const fieldset = this.querySelector('fieldset');
    if (!labels.length || !fieldset) return;
    const families = [...new Set(labels.map((label) => label.dataset.formatFamily))];
    const checked = labels.find((label) => label.querySelector('input:checked')) ?? labels[0];
    this.activeFamily = checked.dataset.formatFamily;
    let tabs = this.querySelector('[data-format-tabs]');
    if (!tabs) {
      const heading = document.createElement('p');
      heading.className = 'jbc-format__eyebrow';
      heading.textContent = this.dataset.title;
      tabs = document.createElement('div');
      tabs.dataset.formatTabs = '';
      tabs.setAttribute('role', 'tablist');
      tabs.setAttribute('aria-label', this.dataset.title);
      this.prepend(heading, tabs);
    }
    const signature = families.join(',');
    if (tabs.dataset.signature !== signature) {
      const buttons = families.map((family) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.formatTab = family;
        button.setAttribute('role', 'tab');
        button.textContent = this.dataset[family] ?? family;
        return button;
      });
      tabs.replaceChildren(...buttons);
      tabs.dataset.signature = signature;
    }
    const picker = this.querySelector('variant-picker');
    const key = `${picker?.dataset.sectionId}-${picker?.dataset.productId}-${picker?.dataset.blockId}`;
    fieldset.id = `JbcFormatPanel-${key}`;
    fieldset.setAttribute('role', 'tabpanel');
    for (const button of tabs.querySelectorAll('button')) {
      const selected = button.dataset.formatTab === this.activeFamily;
      button.id = `JbcFormatTab-${key}-${button.dataset.formatTab}`;
      button.setAttribute('aria-controls', fieldset.id);
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
      if (selected) fieldset.setAttribute('aria-labelledby', button.id);
    }
    for (const label of labels) label.hidden = label.dataset.formatFamily !== this.activeFamily;
    this.dataset.enhanced = 'true';
  };
  selectFamily(family) {
    const labels = Array.from(this.querySelectorAll('label[data-format-family]')).filter((label) => label.dataset.formatFamily === family);
    const target = labels.find((label) => label.querySelector('input')?.dataset.optionAvailable === 'true') ?? labels[0];
    target?.querySelector('input')?.click();
    this.refresh();
  }
  handleTabClick = (event) => {
    const tab = event.target.closest('[data-format-tab]');
    if (tab && this.contains(tab)) this.selectFamily(tab.dataset.formatTab);
  };
  handleTabKey = (event) => {
    const tab = event.target.closest('[data-format-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = Array.from(this.querySelectorAll('[data-format-tab]'));
    const index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    tabs[next].focus();
    this.selectFamily(tabs[next].dataset.formatTab);
  };
}
if (!customElements.get('jbc-format-selector')) customElements.define('jbc-format-selector', JbcFormatSelector);
